<div class="generic-dialog generic-dialog--info ann-dialog">

  <div class="generic-dialog__header ann-dialog__header">
    <div class="ann-dialog__title-row">
      <div class="ann-dialog__title-group">
        <span class="ann-dialog__brand-icon" aria-hidden="true">
          <mat-icon>notifications_active</mat-icon>
        </span>
        <div class="ann-dialog__title-wrap">
          <h3>What's New</h3>
        </div>
      </div>

      <div class="ann-dialog__header-actions">
        <span class="ann-dialog__count" *ngIf="announcements.length; else noUpdatesMeta">
          {{ announcements.length }} update{{ announcements.length === 1 ? '' : 's' }}
        </span>
        <button class="ann-dialog__close" (click)="close()" aria-label="Close">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <ng-template #noUpdatesMeta>
        <span class="ann-dialog__count ann-dialog__count--muted">All caught up</span>
      </ng-template>
    </div>
  </div>

  <div class="generic-dialog__content ann-dialog__content">

    <ng-container *ngIf="announcements.length; else emptyState">
      <div *ngFor="let ann of announcements"
           class="ann-item"
           [class.ann-item--unread]="isUnread(ann.Id)">
        <div class="ann-item__header">
          <span class="ann-item__icon-shell"
                [ngClass]="{
                  'ann-item__icon-shell--alert': ann.Category === 'ALERT',
                  'ann-item__icon-shell--info':  ann.Category === 'INFO',
                  'ann-item__icon-shell--tip':   ann.Category === 'TIP'
                }">
            <mat-icon *ngIf="ann.Category === 'ALERT'">warning</mat-icon>
            <mat-icon *ngIf="ann.Category === 'INFO'">campaign</mat-icon>
            <mat-icon *ngIf="ann.Category === 'TIP'">lightbulb</mat-icon>
          </span>

          <div class="ann-item__meta">
            <div class="ann-item__title-row">
              <strong class="ann-item__title">{{ ann.Title }}</strong>
              <span *ngIf="isUnread(ann.Id)" class="ann-item__badge" aria-label="Unread">New</span>
            </div>

            <div class="ann-item__meta-row">
              <span class="ann-item__tag">{{ ann.Category }}</span>
              <span class="ann-item__time">{{ ann.StartTime | localIso: 'datetime'}}</span>
            </div>
          </div>
        </div>

        <p class="ann-item__desc">{{ ann.Description }}</p>
      </div>
    </ng-container>

    <ng-template #emptyState>
      <div class="ann-empty">
        <span class="generic-dialog__icon-shell ann-empty__icon-shell">
          <mat-icon class="generic-dialog__icon">check_circle</mat-icon>
        </span>
        <p>You're all caught up!</p>
      </div>
    </ng-template>

  </div>
</div>
